import { DataSourceIcon } from '@/lib';
import { DataSource } from '@/models/dataSource';
import { FC } from 'react';

type DataSourceNameColumnProps = {
  datasource: DataSource;
};

export const DataSourceNameColumn: FC<DataSourceNameColumnProps> = ({ datasource }) => {
  return (
    <div className='flex items-center gap-3 ps-px'>
      <DataSourceIcon type={datasource.type.id} />
      <div>
        <p className='text-sm font-medium text-primary-900'>{datasource.name}</p>
        <p className='text-sm text-tertiary-600'>{datasource.type.name}</p>
      </div>
    </div>
  );
};
